export default {
	lang: 'es',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": 'Seguridad de la cuenta',
		"nav1": 'Mi disco en la nube',
		"nav2": 'Cerrar sesión',
		"nav3": 'Iniciar sesión/Registrarse',
		"nav4": 'Puede grabar llamadas y contenido de audio del teléfono y convertirlos a texto. Necesita conectar auriculares de la serie VTransBUDS para usarlos',
		"nav5": 'Escanea el código para descargar',
		"nav6": 'Comunicación importante, retroceso eficiente',
		"speaker_not_null": '¡No se puede editar! El altavoz está vacío',
		"speaker": 'Altavoz',
		"copy_success": 'Copia realizada correctamente',
	},
	login: {
		"login1": 'Iniciar sesión con contraseña',
		"login2": 'Iniciar sesión por SMS',
		"loginTab3": 'Iniciar sesión por correo electrónico',
		"login3": 'Correo electrónico',
		"login4": 'Contraseña de inicio de sesión',
		"login5": 'Número de teléfono móvil',
		"login6": 'Seleccione',
		"login7": 'Código de verificación del teléfono móvil',
		"login8": 'Iniciar sesión',
		"login9": '¿Olvidó su contraseña?',
		"login10": 'Registrarse',
		"login11": 'Iniciar sesión significa que acepta',
		"login12": 'Acuerdo de servicio',
		"login13": 'Acuerdo de privacidad',
		"login14": 'Obtener',
		"login15": 'China',
		"login16": 'Ingrese a su cuenta',
		"login17": 'Ingrese su contraseña',
		"login18": 'Iniciar sesión ¡Éxito!',
		"login19": '¡Ingrese el código de verificación!',
		"login20": '¡Enviado correctamente!',
		"login21": 'Y',
		"login22": 'Disco en la nube de la grabadora',
		"login23": 'Mi escritura',
		"login24": 'Mi conversación',
		"login25": 'Seguridad de la cuenta',
		"login26": 'Cerrar sesión',
		"login27": 'Recuperar contraseña de correo electrónico',
		"login28": 'Correo electrónico',
		"login29": 'Código de verificación de correo electrónico',
		"login30": 'Establecer contraseña de inicio de sesión (6-16 caracteres)',
		"login31": 'Ingrese la contraseña de nuevo',
		"login32": 'Enviar',
		"login33": 'Volver a iniciar sesión',
		"login34": '¡Cambio exitoso!',
	},
	register: {
		"register1": 'Número de teléfono móvil',
		"register2": 'Introduzca su número de teléfono móvil',
		"register3": 'Seleccione',
		"register4": 'Código de verificación del teléfono móvil',
		"register5": 'Establecer contraseña',
		"register6": 'Introduzca el código de verificación',
		"register7": '6-16 caracteres',
		"register8": 'Confirmación de contraseña',
		"register9": 'Correo electrónico',
		"register10": 'Introduzca el correo electrónico',
		"register11": 'Código de verificación del correo electrónico',
		"register12": 'Introduzca el código de verificación',
		"register13": 'He leído y acepto',
		"register14": 'Lea y revise el acuerdo',
		"register15": 'El formato del número de teléfono móvil es incorrecto / El número de teléfono móvil ya está registrado',
		"register16": 'El código de verificación del teléfono móvil es incorrecto',
		"register17": 'Ingrese su correo electrónico / Error en el formato del correo electrónico',
		"register18": 'Error en el formato del correo electrónico',
		"register19": 'Error en el código de verificación del correo electrónico',
		"register20": 'Configure la contraseña entre 6 y 16 caracteres',
		"register21": 'Error en el formato de la contraseña',
		"register22": 'Las dos contraseñas son incoherentes, vuelva a ingresarla',
		"register23": 'Ingrese la contraseña',
		"register24": '¡Registro exitoso!',
		"register25": 'Error en el código de verificación',
	},
	recorder: {
		"recorder1": 'Mi disco en la nube',
		"recorder2": 'Capacidad del espacio en la nube',
		"recorder3": 'Archivos recientes',
		"recorder331": 'Papelera de reciclaje',
		"recorder332": 'Eliminar todo',
		"recorder4": 'Nombre',
		"recorder5": 'Duración del audio',
		"recorder6": 'Tamaño del archivo',
		"recorder7": 'Hora de creación',
		"recorder8": 'Operación',
		"recorder9": 'Descripción del espacio en la nube',
		"recorder10": 'Audio',
		"recorder11": 'Archivo OCR',
		"recorder12": '1. ¿Para qué se utiliza el espacio en la nube?',
		"recorder13": 'Después de grabar con la grabadora, puede subir el audio y los archivos transcritos al espacio en la nube. Incluso si no lleva consigo la grabadora, puede acceder al espacio en la nube para ver el audio.',
		"recorder14": '2. ¿Cómo subir archivos a la nube?',
		"recorder15": 'Entra en [Mis archivos] en la grabadora, selecciona el archivo de destino y mantén pulsado para ver la opción. Haz clic en "Subir" para subir el archivo a la nube.',
		"recorder16": '3. ¿Cómo ver/administrar archivos de la nube?',
		"recorder17": 'Inicia sesión en el sitio web oficial de Beibo, selecciona "Mi disco de nube de grabadora" y podrás ver los archivos de la grabadora subidos. Puedes seleccionar el archivo de destino para descargar, eliminar y realizar otras operaciones. ¡Puedes limpiar el almacenamiento en la nube eliminando los archivos!',
		"recorder18": 'Sin transcribir',
		"recorder19": 'Ver resumen',
		"recorder20": 'Orador',
		"recorder21": 'Editar nombre del orador',
		"recorder22": 'Confirmar',
		"recorder23": 'Descargar',
		"recorder24": 'Descargar contenido:',
		"recorder25": 'Configuración de descarga:',
		"recorder26": 'Mostrar orador',
		"recorder27": 'Cancelar',
		"recorder28": 'Compartir enlace',
		"recorder29": 'Cualquier persona que reciba el enlace puede acceder a él. Solo se permite leer. El enlace es válido por 7 días.',
		"recorder30": 'Copiar enlace',
		"recorder31": 'Escanear y visualizar rápidamente',
		"recorder32": 'Organización inteligente',
		"recorder33": 'Distinguir hablantes',
		"recorder34": 'Distinguir inteligentemente los textos transcritos según los roles del hablante',
		"recorder35": 'Regularización inteligente del lenguaje hablado',
		"recorder36": 'Filtrar automáticamente partículas modales, palabras repetidas y palabras en pausa',
		"recorder37": 'Filtrado de voz no humana',
		"recorder38": 'Omitir automáticamente el audio sin voz humana ni ruido durante la reproducción',
		"recorder39": 'Seleccione',
		"recorder40": 'Documento',
		"recorder41": 'Audio',
		"recorder42": 'Documento+Audio',
		"recorder43":'Mensaje',
		"recorder44":'Esta operación eliminará el archivo. ¿Desea continuar?',
		"recorder441":'Esta operación eliminará todos los archivos. ¿Desea continuar?',
		"recorder45":'Aceptar',
		"recorder46":'Cancelar',
		"recorder47":'¡Eliminado correctamente!',
		"recorder48":'Eliminado cancelado',
		"recorder49":'Aún sin marcar',
		"recorder50":"Guardando...",
		"recorder51":'Papelera de reciclaje',
	},
	personal: {
		"personal1": 'Configuración de la cuenta',
		"personal2": 'Información personal',
		"personal3": 'Avatar',
		"personal4": 'Subir archivo',
		"personal5": 'Compatible con formatos JPG, JPEG, GIF y PNG; admite imágenes de hasta 2 MB',
		"personal6": 'Apodo',
		"personal7": 'Ingresa tu apodo',
		"personal8": 'Género',
		"personal9": 'Sr.',
		"personal10": 'Sra.',
		"personal11": 'Confidencial',
		"personal12": 'Fecha de nacimiento',
		"personal13": 'Selecciona tu fecha de nacimiento',
		"personal14": 'Ocupación',
		"personal15": 'Selecciona tu ocupación',
		"personal16": 'Ingresa tu ocupación (opcional)',
		"personal17": 'País',
		"personal18": 'Selecciona tu país',
		"personal19": 'Guardar',
		"personal20": 'Información personal',
		"personal21": 'Seguridad de la cuenta',
		"personal22": 'Solo se admiten imágenes de hasta 2 MB',
		"personal23": '¡Subida exitosa!',
		"personal24": '¡Cambio exitoso!',
		"personal25": 'Seguridad de la cuenta',
		"personal26": 'Contraseña de inicio de sesión',
		"personal27": 'Cambiar',
		"personal28": 'Correo electrónico',
		"personal29": 'Cambiar',
		"personal30": 'Cancelar cuenta',
		"personal32": '¿Seguro que desea cancelar su cuenta?',
		"personal33": 'Tras la cancelación, se borrará todo el contenido de su cuenta. Tenga cuidado. ',
		"personal34": 'Cancelar',
		"personal35": 'Confirmar',
		"personal36": 'Autenticación',
		"personal37": 'Para confirmar que es usted quien opera, complete la verificación de identidad mediante el código de verificación del correo electrónico',
		"personal38": 'Correo electrónico',
		"personal39": 'Código de verificación',
		"personal40": 'Ingrese el código de verificación',
		"personal41": 'Siguiente',
		"personal42": 'Establecer un nuevo correo electrónico',
		"personal43": 'Correo electrónico',
		"personal44": 'Ingrese un nuevo correo electrónico',
		"personal45": 'Código de verificación',
		"personal46": 'Ingrese el código de verificación',
		"personal47": 'Confirmar',
		"personal48": 'Establecer una nueva contraseña de inicio de sesión',
		"personal49": 'Nueva contraseña de inicio de sesión',
		"personal50": 'Ingrese una nueva contraseña',
		"personal51": 'Confirmar nueva contraseña',
		"personal52": 'Por favor, introduzca la nueva contraseña',
		"personal53": 'Confirmar',
		"personal54": 'Obtener',
		"personal55": 'Error de formato de correo electrónico',
		"personal56": '¡Cambio exitoso!',
		"personal57": 'Por favor, configure la contraseña entre 6 y 16 caracteres',
		"personal58": 'Las dos contraseñas ingresadas son inconsistentes',
		"personal59": '¡Cambio exitoso!',
		"personal60": '¡Cerrar sesión exitosamente!',
		"share_url": "Compartir enlace",
		"share_url_7_day": "El enlace para compartir es válido por 7 días. Antes de que caduque, cualquier persona que lo obtenga podrá acceder a él.",
		"share_audio": "Grabación de audio",
		"share_trans_text": "Transcripción",
		"share_summny_text": "Resumen",
		"share_map": "Mapa mental",
		"share_url_pw": "Cifrado de acceso",
		"share_random_pw": "Contraseña generada aleatoriamente",
		"share_url_copy": "Copiar enlace",
		"share_link_pw": "Contraseña de acceso",
		"share_copy_success": "¡Copia correcta!",
		"share_speaker": "Orador",
		"share_no_update_speaker": "No se puede editar. El orador está vacío",
		"share_no_trans": "Sin transcripción",
		"share_no_summny": "No resumen",
		"share_no_map": "Sin contenido en el mapa",
		"share_trans_text_1": "Transcripción",
		"share_summny_text_1": "Resumen",
		"share_map_1": "Mapa",
		"share_save": "Guardado correctamente",
		"share_no_map": "Imagen del mapa no generada",
		"share_update_text": "Editar el texto de la transcripción",
		"share_update_text2": "Editar el texto del resumen",
		"showLoading": "cargando...",
	}
}